// src/components/PartnersListMe.jsx

import React, { useState, useEffect } from 'react'
import { db } from '../firebase'
import { collection, addDoc } from 'firebase/firestore'
import styles from './partners-listme.module.css'
import {
  FaLinkedin,
  FaGoogle,
  FaChevronLeft,
  FaChevronRight,
  FaPaperclip,
} from 'react-icons/fa'

export default function PartnersListMe({ open, onClose, onProfileAdded }) {
  const [tab, setTab] = useState('guest')      // 'guest' or 'login'
  const [step, setStep] = useState(1)          // 1=form, 2=upload, 3=thanks

  const [guestForm, setGuestForm] = useState({
    entity: 'Individual',
    name: '',
    email: '',
    phone: '',
    others: '',
    skill: '',
    goal: '',
    showKPI: false,
    resources: [{ text: '', qty: '' }],
    tags: '',
  })

  const [loginForm, setLoginForm] = useState({
    name: '',
    password: '',
    remember: false,
  })

  // load / persist draft when modal opens
  useEffect(() => {
    if (!open) return
    const saved = JSON.parse(localStorage.getItem('partnerForm') || '{}')
    if (saved.guestForm) setGuestForm(saved.guestForm)
    if (saved.step) setStep(saved.step)
  }, [open])

  useEffect(() => {
    localStorage.setItem('partnerForm', JSON.stringify({ guestForm, step }))
  }, [guestForm, step])

  const addResourceRow = () => {
    setGuestForm(f => ({
      ...f,
      resources: [...f.resources, { text: '', qty: '' }],
    }))
  }

  const handleFileDrop = async e => {
    e.preventDefault()
    const file = e.dataTransfer?.files[0] || e.target.files[0]
    if (!file) return
    const text = await file.text()
    const m = text.match(/Name:\s*(\w+\s\w+)/)
    if (m) setGuestForm(f => ({ ...f, name: m[1] }))
  }

  const handleGuestSubmit = async () => {
    if (step === 1) {
      setStep(2)
      return
    }
    if (step === 2) {
      try {
        const tags = guestForm.tags
          .split(',')
          .map(t => t.trim())
          .filter(Boolean)


          
          const cleaned = {
            ...guestForm,
                 entityName: guestForm.name || '',          // for card header
          
                 // drop completely blank rows, default qty to "1"
                 resources: (guestForm.resources || [])
                 .filter(r => (r.text ?? '').trim() || (r.qty ?? '').trim())
                   .map(r => ({
                     text: (r.text ?? '').trim(),
                     qty : (r.qty  ?? '1').trim(),
                   })),
          
                 tags,                                      // already an array
               }
               
          
          
            

               await addDoc(collection(db, 'profiles'), cleaned)



        onProfileAdded()
        setStep(3)
      } catch (err) {
        console.error(err)
      }
    }
  }

  const handleLogin = () => {
    console.log('Logging in with', loginForm)
  }

  if (!open) return null

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>

        {/* ───── Header + Tabs ───── */}
        <div className={styles.modalHeader}>
          <h2>Find Your Perfect Match</h2>
          <div className={styles.tabBar}>
            <button
              className={tab === 'guest' ? styles.activeTab : styles.tab}
              onClick={() => { setTab('guest'); setStep(1) }}
            >
              Continue as Guest
            </button>
            <button
              className={tab === 'login' ? styles.activeTab : styles.tab}
              onClick={() => setTab('login')}
            >
              Login Account
            </button>
          </div>
        </div>

        {/* ───── Content ───── */}
        <div className={styles.content}>

          {/* ─ Guest: Step 1 ─ */}
          {tab === 'guest' && step === 1 && (
            <>
              <h3>Contact Info</h3>

              <fieldset className={styles.entityGroup}>
                <legend>Identity</legend>
                {['Individual','Company','AI Agent'].map(opt => (
                  <label key={opt}>
                    <input
                      type="radio"
                      name="entity"
                      checked={guestForm.entity === opt}
                      onChange={() => setGuestForm(f => ({ ...f, entity: opt }))}
                    />
                    <span>{opt}</span>
                  </label>
                ))}
              </fieldset>

              <div className={styles.twoColRow}>
                <label>
                  <span>Name</span>
                  <input
                    value={guestForm.name}
                    onChange={e =>
                      setGuestForm(f => ({ ...f, name: e.target.value }))
                    }
                  />
                </label>
                
                <label>
                  <span>Email</span>
                  <input
                    type="email"
                    value={guestForm.email}
                    onChange={e =>
                      setGuestForm(f => ({ ...f, email: e.target.value }))
                    }
                  />
                </label>
              </div>

              <div className={styles.twoColRow}>
                <label>
                  <span>Phone</span>
                  <input
                    value={guestForm.phone}
                    onChange={e =>
                      setGuestForm(f => ({ ...f, phone: e.target.value }))
                    }
                  />
                </label>
                <label>
                  <span>Others</span>
                  <input
                    value={guestForm.others}
                    onChange={e =>
                      setGuestForm(f => ({ ...f, others: e.target.value }))
                    }
                  />
                </label>
              </div>

              <hr />

              <h3>Let’s find the perfect match</h3>

              <div className={styles.fullWidthBlock}>
                <label>
                  <span>Who are you & what you’re good at?</span>
                  <input
                    value={guestForm.skill}
                    onChange={e =>
                      setGuestForm(f => ({ ...f, skill: e.target.value }))
                    }
                  />
                </label>
              </div>

              <div className={styles.fullWidthBlock}>
                <label>
                  <span>Your Goal</span>
                  <input
                    value={guestForm.goal}
                    onChange={e =>
                      setGuestForm(f => ({ ...f, goal: e.target.value }))
                    }
                  />
                </label>
              </div>

              <button
                className={styles.linkButton}
                onClick={() =>
                  setGuestForm(f => ({ ...f, showKPI: !f.showKPI }))
                }
              >
                + add advanced KPI
              </button>

              {guestForm.showKPI && (
                <label>
                  <span>KPI</span>
                  <input placeholder="e.g. 100k impressions" />
                </label>
              )}

              <div className={styles.resourceHeader}>
                <span>Free resources you can share with others</span>
                <span>Quantity</span>
              </div>
              {guestForm.resources.map((r,i) => (
                <div key={i} className={styles.resourceRow}>
                  <input
                    value={r.text}
                    placeholder="Resource name"
                    onChange={e => {
                      const copy = [...guestForm.resources]
                      copy[i].text = e.target.value
                      setGuestForm(f => ({ ...f, resources: copy }))
                    }}
                  />
                  <input
                    value={r.qty}
                    placeholder="Qty"
                    onChange={e => {
                      const copy = [...guestForm.resources]
                      copy[i].qty = e.target.value
                      setGuestForm(f => ({ ...f, resources: copy }))
                    }}
                  />
                </div>
              ))}
              <button
                className={styles.linkButton}
                onClick={addResourceRow}
              >
                + add free resources
              </button>

              <label className={styles.keywordsLabel}>
                <span>Keywords (comma-separated)</span>
                <input
                  placeholder="#creator, video"
                  value={guestForm.tags}
                  onChange={e =>
                    setGuestForm(f => ({ ...f, tags: e.target.value }))
                  }
                />
              </label>

              <div className={styles.modalControls}>
                <button className={styles.outlineButton} onClick={onClose}>
                  Cancel
                </button>
                <button
                  className={styles.primaryButton}
                  onClick={handleGuestSubmit}
                >
                  Next <FaChevronRight/>
                </button>
              </div>
            </>
          )}

          {/* ─ Guest: Step 2 ─ */}
          {tab === 'guest' && step === 2 && (
            <>
              <h3>Upload Any Document</h3>
              <p className={styles.uploadDesc}>
                Upload your doc so we can understand you better
              </p>
              <div
                className={styles.dropZone}
                onDrop={handleFileDrop}
                onDragOver={e => e.preventDefault()}
              >
                <FaPaperclip size={24}/>
                <p>Upload any file so we can understand you better</p>
                <input
                  type="file"
                  onChange={handleFileDrop}
                  className={styles.fileInput}
                />
              </div>
              <div className={styles.modalControls}>
                <button
                  className={styles.outlineButton}
                  onClick={() => setStep(1)}
                >
                  <FaChevronLeft/> Back
                </button>
                <button
                  className={styles.primaryButton}
                  onClick={handleGuestSubmit}
                >
                  Submit
                </button>
              </div>
            </>
          )}

          {/* ─ Guest: Step 3 ─ */}
          {tab === 'guest' && step === 3 && (
            <div className={styles.thanks}>
              <p>🎉 Thanks! We’ll be in touch soon.</p>
              <button
                className={styles.primaryButton}
                onClick={onClose}
              >
                Close
              </button>
            </div>
          )}

          {/* ─ Login Flow ─ */}
          {tab === 'login' && (
            <div className={styles.loginPane}>
              <h3>Lex Partnership Account</h3>
              <label>
                <span>Email</span>
                <input
                  value={loginForm.email}
                  onChange={e =>
                    setLoginForm(l => ({ ...l, email: e.target.value }))
                  }
                />
              </label>
              <label>
                <span>Password</span>
                <input
                  type="password"
                  value={loginForm.password}
                  onChange={e =>
                    setLoginForm(l => ({ ...l, password: e.target.value }))
                  }
                />
              </label>
              <div className={styles.loginLinks}>
                <label>
                  <input
                    type="checkbox"
                    checked={loginForm.remember}
                    onChange={e =>
                      setLoginForm(l => ({ ...l, remember: e.target.checked }))
                    }
                  />x
                  Remember me
                </label>
                <a href="#" className={styles.forgot}>Forgot password?</a>
              </div>
              <div className={styles.modalControls}>
                <button className={styles.primaryButton} onClick={handleLogin}>
                  Login
                </button>
                <button className={styles.primaryButton} onClick={() => console.log('Sign Up')}>
                  Sign Up
                </button>
              </div>
              <hr className={styles.divider}/>
              <div className={styles.socialLogin}>
                <button className={styles.ssoButton}><FaLinkedin/> LinkedIn</button>
                <button className={styles.ssoButton}><FaGoogle/> Google</button>
              </div>
            </div>
          )}

        </div>{/* /.content */}
      </div>
    </div>
  )
}
